export class ConfidentialityPage {
    private confidentialityData: { hasAccepted: boolean; lastUpdated: string | null }; // Holds the confidentiality state
    private lastAcceptedDateElement: HTMLElement | null; // Element displaying the last accepted date

    constructor(confidentialityData: { hasAccepted: boolean; lastUpdated: string | null }) {
        this.confidentialityData = confidentialityData; // Initialize confidentiality data
        this.lastAcceptedDateElement = document.getElementById("last-accepted-date"); // Get the last accepted date element

        this.init(); // Initialize the page
    }

    private init(): void {

        // Set the initial last accepted date if available
        if (this.confidentialityData.lastUpdated && this.lastAcceptedDateElement) {
            this.lastAcceptedDateElement.innerHTML = `${new Date(this.confidentialityData.lastUpdated).toLocaleString()}`;
        }

        // Set up the "Re-Accept" and "Decline" button event listeners
        this.setupReacceptButton();
        this.setupDeclineButton();
    }

    private setupReacceptButton(): void {
        const reacceptButton = document.getElementById("reaccept-button"); // Get the "Re-Accept" button
        if (!reacceptButton) return;

        reacceptButton.addEventListener("click", async () => {
            try {
                // Send a POST request to accept the confidentiality agreement
                const response = await fetch(window.location.pathname + "?handler=UpdateConfidentiality", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ hasAccepted: true }), // Pass the acceptance state
                });

                const data = await response.json();
                if (data.success && this.lastAcceptedDateElement) {
                    // Update the last accepted date on the page
                    this.lastAcceptedDateElement.innerHTML = `${new Date(data.lastUpdated).toLocaleString()}`;
                }
            } catch (error) {
                alert("An error occurred while accepting the agreement. Please try again.");
            }
        });
    }

    private setupDeclineButton(): void {
        const declineButton = document.getElementById("decline-button"); // Get the "Decline" button
        if (!declineButton) return;

        declineButton.addEventListener("click", async () => {
            try {
                // Send a POST request to decline the confidentiality agreement
                const response = await fetch(window.location.pathname + "?handler=UpdateConfidentiality", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ hasAccepted: false }), // Pass the decline state
                });

                if (response.ok) {
                    const data = await response.json();
                    if (data.success && data.redirect) {
                        // Store the error message in localStorage for the login page
                        if (data.errorMessage) {
                            localStorage.setItem("loginErrorMessage", data.errorMessage);
                        }

                        // Redirect to the specified URL after sign-out
                        window.location.href = data.redirect;
                    }
                } else {
                    alert("An error occurred while declining the agreement. Please try again.");
                }
            } catch (error) {
               
                alert("An error occurred while declining the agreement. Please try again.");
            }
        });
    }
}